import { Link } from "react-router-dom";
const villaHighlights = [
  {
    title: "Ein ruhiger R\xFCckzugsort, der neue Energie entfacht",
    image: "/images/Hiru/public_images/BBC70E26-89D8-475D-A68B-CA85A81C2953.webp",
    paragraphs: [
      "Alle 18 G\xE4stezimmer sind in einem historischen Kolonialgeb\xE4ude und in einem modernen Neubau untergebracht. Beide Bereiche schaffen einen harmonischen, ruhigen Raum, in dem der Geist zur Ruhe kommt. Jedes der gro\xDFz\xFCgigen Zimmer mit etwa 32 m\xB2 verf\xFCgt \xFCber eine eigene Terrasse oder ein eigenes Balkon, von wo aus man bei ruhiger Meereskulisse einen entspannten Moment genie\xDFen kann.",
      "Damit Sie sich bei Ihrem Aufenthalt hier in Sicherheit und Komfort f\xFChlen, ist die Ausstattung der Zimmer besonders sorgf\xE4ltig geplant."
    ],
    list: [
      "F\xFCr einen erholsamen Schlaf: In jedem Zimmer gibt es neben einem Deckenventilator auch Klimaanlage und ein Moskitonetz.",
      "Sicherheits- und Komfortfeatures: Dusche, F\xF6hn, Safe, Telefon, kostenloses WLAN."
    ]
  },
  {
    title: "Freie Freizeit zwischen Meer und Gr\xFCn",
    image: "/images/Hiru/public_images/680A2315-Enhanced-NR-2-Edit-copy.webp",
    paragraphs: [
      "Neben einer direkten Treppe zum Strand k\xF6nnen Sie auch eine entspannte Zeit im neu angelegten Infinity-Swimmingpool genie\xDFen. Entspannen Sie sich auf der sonnigen Terrasse oder in den Liegest\xFChlen im tropischen Garten unter den Palmen und genie\xDFen Sie die Zeit in vollen Z\xFCgen.",
      "Dar\xFCber hinaus stehen Ihnen ein Yoga-Pavillon auf einer Klippe mit Blick auf die beeindruckende Landschaft des Indischen Ozeans, Fitnessger\xE4te und offene Gemeinschaftsbereiche zur freien Nutzung zur Verf\xFCgung. So k\xF6nnen Sie in vollkommener Ruhe und Geborgenheit die Zeit genie\xDFen, als w\xE4ren Sie zu Hause."
    ]
  },
  {
    title: "Ayurvedische K\xFCche mit Live-Feeling",
    image: "/images/Hiru/front_panchkarma_teaser.webp",
    paragraphs: [
      "Im 2018 neu er\xF6ffneten Restaurant genie\xDFen Sie Ihre Mahlzeiten in einer einzigartigen Lage direkt am Pool und am Indischen Ozean \u2013 abgestimmt auf Ihren individuellen K\xF6rperbau und Ihre Bed\xFCrfnisse.",
      "Durch die gl\xE4serne K\xFCche k\xF6nnen Sie beobachten, wie die K\xF6che mit frischen Zutaten und viel Liebe die Speisen zubereiten. Genie\xDFen Sie das besondere Erlebnis von Genuss und Gesundheit zugleich."
    ],
    link: { label: "Mehr \xFCber die ayurvedische K\xFCche erfahren", href: "/ayurveda/food" }
  },
  {
    title: "Spezialisten und erfahrene Therapeuten",
    image: "/images/Hiru/public_images/680A2401-Enhanced-NR-2-Edit-copy.webp",
    paragraphs: [
      "Das Ayurveda-Zentrum, der Ausgangspunkt aller Heilung, verf\xFCgt \xFCber 10 Behandlungsr\xE4ume. In dieser ruhigen und besonderen Umgebung f\xFChren qualifizierte Ayurveda-\xC4rzte und erfahrene Therapeuten Ihre Behandlungen sorgf\xE4ltig durch.",
      "Bei gutem Wetter k\xF6nnen Sie auch leichtes Wellnessprogramm wie Fu\xDFmassage, Gesichtsmassage oder Blumensaftb\xE4der im wundersch\xF6nen Garten genie\xDFen. Umgeben von warmem Tropenwind und Blumen duftet die Atmosph\xE4re wie eine ruhige Oase f\xFCr K\xF6rper und Geist."
    ],
    links: [
      { label: "Mehr \xFCber die Behandlungen erfahren", href: "/ayurveda/panchakarma" },
      { label: "Ayurveda-Panchakarma", href: "/ayurveda/panchakarma" }
    ]
  }
];
const AboutVilla = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Hiru Villa / Maggona
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Der Beginn an einem Hang mit Blick auf das Meer
                    </h2>
                    <div className="mx-auto mt-8 flex h-28 w-64 items-center justify-center sm:h-36 sm:w-80">
                        <img
    src="/images/Logos/hiru_villa.webp"
    alt="Logo des Hiru Villa Ayurveda Resorts"
    width={320}
    height={144}
    className="h-full w-full object-contain" loading="lazy" />
                    </div>
                    <div className="mx-auto mt-8 max-w-3xl space-y-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            Hiru Villa, eingebettet in die atemberaubende Landschaft der südwestlichen Küste Sri Lankas, ist der Ursprung des Hiru Ayurveda Resorts, das 2009 entstand. Es ist Ihr ruhiger und vertrauter Rückzugsort, der von Tradition und Vertrauen getragen wird.
                        </p>
                        <p>
                            Hier empfangen Sie ein familiäres Team, das Sie mit offenen Armen willkommen heißt. Sobald Sie eintreten, werden Sie die warmen Winde auf dem Hügel und das Panorama des Indischen Ozeans spüren – und damit die täglichen Spannungen langsam loslassen.
                        </p>
                    </div>
                </div>

                <div className="mx-auto mt-14 grid max-w-7xl gap-7 md:grid-cols-2 lg:mt-20 lg:gap-9">
                    {villaHighlights.map((highlight) => <article
    key={highlight.title}
    className="overflow-hidden rounded-[24px] bg-[#fbfaf7] shadow-[0_20px_60px_rgba(16,38,26,0.08)]"
  >
                            <div className="relative h-72 sm:h-80 lg:h-96">
                                <img
    src={highlight.image}
    alt={highlight.title}
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/70 via-transparent to-transparent" />
                                <h3 className="absolute inset-x-5 bottom-5 font-serif text-2xl font-semibold leading-tight text-white sm:text-3xl">
                                    {highlight.title}
                                </h3>
                            </div>

                            <div className="p-6 sm:p-7">
                                <div className="space-y-4 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                                    {highlight.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                                </div>

                                {highlight.list ? <ul className="mt-5 space-y-3 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                                        {highlight.list.map((item) => <li key={item}>{item}</li>)}
                                    </ul> : null}

                                {highlight.link ? <Link
    to={highlight.link.href}
    className="mt-6 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
  >
                                        » {highlight.link.label}
                                    </Link> : null}

                                {highlight.links ? <div className="mt-6 flex flex-wrap gap-3">
                                        {highlight.links.map((link) => <Link
    key={link.label}
    to={link.href}
    className="inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
  >
                                                » {link.label}
                                            </Link>)}
                                    </div> : null}
                            </div>
                        </article>)}
                </div>

                <div className="mx-auto mt-7 max-w-7xl rounded-[24px] bg-[#f8f5ef] p-6 shadow-[0_20px_60px_rgba(16,38,26,0.06)] sm:p-8 lg:mt-9">
                    <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                        Freie Zeit in Maggona
                    </h3>
                    <div className="mt-5 grid gap-5 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base lg:grid-cols-2">
                        <p>
                            Selbst inmitten eines intensiven Ayurveda-Programms bleiben Ihnen genügend freie Stunden, um das Resort zu verlassen und neue Energie zu tanken. Besuchen Sie die ruhigen Fischerorte in Maggona, fahren Sie in die belebten Städte Kalutara oder Beruwala oder genießen Sie eine Bootsfahrt zu den idyllischen Inseln.
                        </p>
                        <p>
                            Wenn Sie einen Ausflug planen möchten, sprechen Sie uns gerne an. Wir begleiten Sie dabei mit viel Herz und helfen Ihnen, Ihren Aufenthalt noch schöner zu gestalten.
                        </p>
                    </div>
                </div>
            </div>
        </section>;
};
export default AboutVilla;
